export const FormErrorMsg = (props: any): JSX.Element => {
    return (
        <div className="w-full font-normal text-left" style={{ color: "red" }}>
            {props.msg}
        </div>
    );
};
